"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPrintsPrintableGroups;
const uuid_1 = require("uuid");
const either_1 = require("../../types/either");
const createPrintsPrintable_1 = __importDefault(require("./createPrintsPrintable"));
function createPrintsPrintableGroups(userId, projectId, creationDate, template, designId) {
  let currentPrintableGroups = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  const newPrintableGroups = [...currentPrintableGroups];
  const numPrintableGroupsNeeded = template.pages.min - currentPrintableGroups.length;
  for (let i = 0; i < numPrintableGroupsNeeded; i++) {
    const printableGroupId = (0, uuid_1.v5)(`Time ${creationDate} Printable Group ${i}`, projectId);
    const printableId = (0, uuid_1.v5)(`Time ${creationDate} Printable ${i}`, printableGroupId);
    const createPrintsPrintableResult = (0, createPrintsPrintable_1.default)(userId, projectId, creationDate, template, designId, printableId);
    if (createPrintsPrintableResult.isLeft()) {
      return (0, either_1.left)(createPrintsPrintableResult.value);
    }
    newPrintableGroups.push({
      id: printableGroupId,
      qty: 1,
      printables: [createPrintsPrintableResult.value]
    });
  }
  return (0, either_1.right)(newPrintableGroups);
}